import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _toArray from "@babel/runtime/helpers/toArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
var _excluded = ["targetTagName", "onClose", "children"];
import * as React from 'react';
import cn from 'classnames';
import { ensureElement, isDefined } from '../../../library';
import { Dialog } from './dialog';
export var AttachedDialog = function AttachedDialog(props) {
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isOpen = _React$useState2[0],
    setIsOpen = _React$useState2[1];
  var handleTargetClick = function handleTargetClick(e) {
    if (isOpen) {
      setIsOpen(false);
    } else {
      setIsOpen(true);
    }
  };
  var handleClose = function handleClose() {
    setIsOpen(false);
  };
  var renderTarget = function renderTarget() {
    var targetTagName = props.targetTagName,
      children = props.children;
    var _React$Children$toArr = React.Children.toArray(children),
      _React$Children$toArr2 = _toArray(_React$Children$toArr),
      rawTarget = _React$Children$toArr2[0],
      rest = _React$Children$toArr2.slice(1);
    var safeTarget = ensureElement(rawTarget);
    var targetClasses = cn({
      '-dialog-open': isOpen
    });
    var TagName = targetTagName;
    return React.createElement(React.Fragment, null, isDefined(TagName) ? React.createElement(TagName, {
      className: targetClasses,
      onClick: handleTargetClick,
      children: rawTarget
    }) : (React.cloneElement(safeTarget, {
      className: targetClasses,
      onClick: handleTargetClick
    })), rest);
  };
  var targetTagName = props.targetTagName,
    onClose = props.onClose,
    children = props.children,
    dialogProps = _objectWithoutProperties(props, _excluded);
  return React.createElement(React.Fragment, null, renderTarget(), React.createElement(Dialog, _extends({}, dialogProps, {
    isOpen: isOpen,
    onClose: handleClose
  }), props.content));
};
AttachedDialog.displayName = 'AttachedDialog';
AttachedDialog.defaultProps = {};